<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <treeselect
      :value="value"
      @input="updateValue($event)"
      :options="options"
      :load-options="loadUserOptions"
      :normalizer="userNormalizer"
      :placeholder="placeholder"
      :disabled="disabled"
      :clearable="clearable"
      disableFuzzyMatching
      class="form-input-select"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";
import { mapActions } from "vuex";

export default {
  name: "InputTypeTreeSelectUser",

  mixins: [inputTypeMixin],

  props: {
    clearable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      options: null
    };
  },

  methods: {
    ...mapActions(["fetchAllUsers"]),

    loadUserOptions({ callback }) {
      this.fetchAllUsers()
        .then(resp => {
          this.options = resp.data.data;
        })
        .catch(error => {
          console.error(error);
        })
        .then(() => {
          callback();
        });
    },

    userNormalizer(node) {
      let userName = node.first_name;
      if (node.last_name) {
        userName += " " + node.last_name;
      }
      return { id: node.id, label: userName };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/InputTypes/InputTypeTreeSelectUser.vue